import { injectIntl } from '@atlassian/jira-intl/src/index.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { CUSTOMER_SERVICE_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { getProjectKey, getBaseUrl, getProjectType } from '../../../state/selectors/base/index.tsx';
import type { State } from '../../../state/types.tsx';
import KnowledgeBaseBreadcrumb from './view.tsx';

const mapStateToProps = (state: State) => ({
	projectKey: getProjectKey(state),
	baseUrl: getBaseUrl(state),
	isTeamResources:
		getProjectType(state) === CUSTOMER_SERVICE_PROJECT &&
		fg('berry-5110-new-title-for-jcs-knowledge-nav-item'),
});

export default connect(mapStateToProps, {})(injectIntl(KnowledgeBaseBreadcrumb));
